<template>
	<div>
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
			<freeUserTips :type="4" :bgtype="0"></freeUserTips>
		</el-dialog>
		<dl class="opport-screen bdbe">
			<dt class="fl">热点产业</dt>
			<dd class="fl">
				<span 
				:key="index" v-for="(item,index) in hotindustry" 
				@click="industrychoose(1,item);" :class="industrycode1 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="hotindustrychild.length>0">
			<dt class="fl titleop">细分产业</dt>
			<dd class="fl">
				 <span v-if="type == 'invest'" @click="industrycode2='';getdynamiclist()" :class="industrycode2 == ''?'a-screen current':'a-screen'">全部</span>
					<span 
					:key="index"  v-for="(item,index) in hotindustrychild" @click="industrychoose(2,item);" 
					:class="industrycode2 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
			</dd>
		</dl>
	</div>
</template>

<script>
export default {
		name: 'investDynamic',
		data: function(){
			return{
				hotindustry:[],
				hotindustrychild:[],
				industrycode1:0,
				industrycode2:0,
				industryid:0,
				userdata:{},
				isShowFreeUserTips:false,
			}},
			props:{
				type:{type:String,default:"invest"}, 
				token:{type:String,default:""}, 
				refreshNum:{type:Number,default:1}
			},
			watch:{
				refreshNum:{
					handler(newval,oldval){
						this.refreshNum=newval;
						this.industrycode1=0;
						this.industrycode2=0;
						this.industryid=0;
						this.hotindustrychild=[];
						this.gethotindustry();
					}
				},
				type:{
					handler(newval,oldval){
						this.type=newval;
						this.industrycode1=0;
						this.industrycode2=0;
						this.industryid=0;
						this.hotindustrychild=[];
						this.gethotindustry();
					}
				}
			},
			mounted() {
				this.userdata = this.getuseriformation();
				this.gethotindustry();
			},
			methods:{
				industrychoose(step,list){
					if(!this.userdata.token){
						this.isShowFreeUserTips =true;
						return;
					}
					if(list.value == this.industryid){return;}
					var dtsg=[];
				 if(step == 1){
						this.hotindustrychild=list.children; 
						this.industrycode2='';
						this.industrycode1=list.value;
					}else if(step == 2){
						this.industrycode2=list.value;
					};
					this.industryid=list.value;
					this.getdynamiclist();
				} ,
				getdynamiclist(){
					this.$emit('getIndustryId',this.industryid,this.industrycode1,this.industrycode2);
				},
				//获取热点行业分类
				gethotindustry(){
					var _this=this;
					var ajaxurl="";
					if(this.type == 'land'){
						ajaxurl=this.$api.enterpriseapi.parameter.landindustry();
					}else if(this.type == 'invest'){
						ajaxurl=this.$api.investapi.parameter.list()+"?categoryId=1";
					}
					this.$axios.get( ajaxurl, {
						headers: {
							AuthToken: this.token
						}
					}).then(function(res) { 
						let data2=res.data.list;
						if (res.data.success) {
							if(_this.type == 'invest'){
								data2=res.data.list.filter(list=>{
									return list.parentId*1<1;
								})
							} 
							// console.log(res.data.list)
							data2.unshift({name:"全部",value:0,children:[]});
						_this.hotindustry=data2; 
						} else {
							
						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
				},
			}
}
</script>

<style>
</style>